import { DATA_RETENTION, DATA_RETENTION_WINDOWS, DATA_RETENTION_WINDOW_DAYS, DEFAULT_DATA_RETENTION } from '../ai-agents.constants';

const MIN_RETENTION_DAYS_FLOOR = 14;

export function dataRetentionFromAgent (aiAgent) {
    if (aiAgent?.zeroRetentionEnabled) {
        return DATA_RETENTION.NEVER_STORE;
    }

    return DATA_RETENTION_WINDOWS.find((id) => DATA_RETENTION_WINDOW_DAYS[id] === aiAgent?.rawDataRetentionDays) ?? DEFAULT_DATA_RETENTION;
}

export function retentionWindowField (dataRetention) {
    const rawDataRetentionDays = DATA_RETENTION_WINDOW_DAYS[dataRetention];

    return rawDataRetentionDays ? { rawDataRetentionDays } : {};
}

export function retentionPatchOps (dataRetention, aiAgent) {
    const ops = [];
    const zeroRetentionEnabled = dataRetention === DATA_RETENTION.NEVER_STORE;

    if (Boolean(aiAgent?.zeroRetentionEnabled) !== zeroRetentionEnabled) {
        ops.push({ op: 'replace', path: '/zeroRetentionEnabled', value: zeroRetentionEnabled });
    }

    const { rawDataRetentionDays } = retentionWindowField(dataRetention);
    if (rawDataRetentionDays && aiAgent?.rawDataRetentionDays !== rawDataRetentionDays) {
        ops.push({ op: 'replace', path: '/rawDataRetentionDays', value: rawDataRetentionDays });
    }

    return ops;
}

export function minRetentionDaysFor (stragglerDays) {
    return Math.max(MIN_RETENTION_DAYS_FLOOR, (stragglerDays || 0) + 1);
}

export function retentionErrorMessage (error) {
    const body = error?.response?.data;

    return typeof body === 'string' ? body.trim() : body?.message;
}
